import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  useTheme,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import GetAppIcon from '@mui/icons-material/GetApp';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import SecurityIcon from '@mui/icons-material/Security';

export default function InstaladoresDownloads() {
  const theme = useTheme();

  const handleDownloadAgent = () => {
    // URL de download do agente Delphi de Backup Fácil
    window.open("https://srvbkp.backupfacil.com/instaladores/BackupFacilAgent.exe", "_blank");
  };

  return (
    <Box sx={{ flexGrow: 1, p: 1 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 3, color: "text.primary" }}>
        Central de Downloads e Instaladores
      </Typography>

      <Grid container spacing={3}>
        {/* Card do Agente de Backup */}
        <Grid item xs={12} md={7}>
          <Card
            sx={{
              borderRadius: "16px",
              boxShadow: "none",
              border: `1px solid ${theme.palette.divider}`,
              background: theme.palette.mode === 'dark' ? "linear-gradient(135deg, #1e293b, #0f172a)" : "#ffffff"
            }}
          >
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 3 }}>
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, color: "text.primary" }}>
                    Agente de Backup (Delphi)
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Instalador oficial para Windows do serviço cliente de sincronização de arquivos e bancos de dados.
                  </Typography>
                </Box>
                <DownloadIcon sx={{ color: theme.palette.primary.main, fontSize: 32 }} />
              </Box>

              <Grid container spacing={2} sx={{ mb: 4 }}>
                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    VERSÃO DO PORTAL
                  </Typography>
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                    v2.4.2
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    TAMANHO DO ARQUIVO
                  </Typography>
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                    ~ 12.8 MB
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="caption" color="text.secondary" display="block">
                    SISTEMA OPERACIONAL
                  </Typography>
                  <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                    Windows 10 / 11 / Server
                  </Typography>
                </Grid>
              </Grid>

              <Divider sx={{ my: 3 }} />

              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: "text.primary" }}>
                Instruções Rápidas de Implantação
              </Typography>

              <List dense>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <CheckCircleOutlineIcon fontSize="small" color="primary" />
                  </ListItemIcon>
                  <ListItemText 
                    primary="1. Efetue o download do executável no botão abaixo." 
                    primaryTypographyProps={{ fontSize: '0.85rem', color: "text.primary" }}
                  />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <SettingsSuggestIcon fontSize="small" color="primary" />
                  </ListItemIcon>
                  <ListItemText 
                    primary="2. Execute como Administrador e configure com as credenciais do cliente criado no portal." 
                    primaryTypographyProps={{ fontSize: '0.85rem', color: "text.primary" }}
                  />
                </ListItem>
                <ListItem disableGutters>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <SecurityIcon fontSize="small" color="primary" />
                  </ListItemIcon>
                  <ListItemText 
                    primary="3. Defina as tarefas de backup (Arquivos ou Bancos de Dados) e valide a conexão com a nuvem." 
                    primaryTypographyProps={{ fontSize: '0.85rem', color: "text.primary" }}
                  />
                </ListItem>
              </List>

              <Box sx={{ mt: 4 }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<GetAppIcon />}
                  onClick={handleDownloadAgent}
                  sx={{ borderRadius: "8px", px: 4, textTransform: "none", fontWeight: 700 }}
                >
                  Baixar Agente (.exe)
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Informações adicionais */}
        <Grid item xs={12} md={5}>
          <Card sx={{ borderRadius: "16px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none" }}>
            <CardContent sx={{ p: 4 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: "text.primary" }}>
                Suporte Técnico ao Representante
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
                Como revendedor oficial do Backup Fácil, você possui suporte prioritário de nossa equipe de engenharia para migrações complexas de servidores ou bancos de dados volumosos (SQL Server, Oracle, PostgreSQL).
              </Typography>

              <Box sx={{ p: 2, bgcolor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.02)", borderRadius: "8px" }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5, color: "text.primary" }}>
                  Dúvidas Frequentes:
                </Typography>
                <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 1 }}>
                  • Como configurar backups remotos? Use a aba "Gerenciador de Tarefas Remoto" no painel do cliente nesta plataforma para criar e ajustar agendamentos de backup sem precisar abrir o cliente local.
                </Typography>
                <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }}>
                  • Onde o agente Delphi salva os arquivos temporários? O agente Delphi sincroniza diretamente com nosso Storage em nuvem segmentado, utilizando criptografia AES-256 e compactação Gzip.
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
